import { useEffect, useRef, useState } from "react";
import { ref, onValue, query } from "firebase/database";
import meter1 from "../../images/meter1.png";
import meter2 from "../../images/meter2.png";
import meter3 from "../../images/meter3.png";
import meter4 from "../../images/meter4.png";
import { fireStore } from "../../firebaseConfig";
import { collection, getDocs, where } from "firebase/firestore";
import { database } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 7);

  const [startDate, setStartDate] = useState(threeDaysAgo.getTime()); // Store as milliseconds
  const [endDate, setEndDate] = useState(Date.now());

  const [notifications, setNotifications] = useState([]);
  const [totalKMS, setTotalKMS] = useState(0);
  const [totalPKR, setTotalPKR] = useState(0);
  const [fuelAverage, setFuelAverage] = useState(0);
  const [activityCount, setActivityCount] = useState(0);
  const [uniqueProductCount, setUniqueProductCount] = useState(0);
  const [fmCount, setFmCount] = useState(0);
  const [fdCount, setFdCount] = useState(0);
  const [totalParticipants, setTotalParticipants] = useState(0);
  const [totalExp, setTotalExp] = useState(0);
  const [fulfilledPercentage, setFulfilledPercentage] = useState(0);
  const [skippedPercentage, setSkippedPercentage] = useState(0);
  const [fulfilledSSPercentage, setFulfilledSSPercentage] = useState(0);
  const [skippedSSPercentage, setSkippedSSPercentage] = useState(0);
  const [reportFMCoachingCount, setReportFMCoachingCount] = useState(0);
  const [reportSSCoachingCount, setReportSSCoachingCount] = useState(0);
  const [totalFarmers, setTotalFarmers] = useState(0);
  const [totalTerritories, setTotalTerritories] = useState(0);
  const [areavisits, setAreaVisits] = useState([]);
  const audioRef = useRef(null);

  const navigate = useNavigate();

  const fetchLogbooks = async () => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const pastDate = new Date();
      pastDate.setDate(today.getDate() - 1);
      pastDate.setHours(0, 0, 0, 0);

      const collRef = collection(fireStore, "LogBooks");
      const q = query(
        collRef,
        where("time", ">=", pastDate),
        where("time", "<=", today)
      );
      const querySnapshot = await getDocs(q);

      let totalKMS = 0,
        totalPKR = 0,
        totalFuelQuantity = 0,
        fuelAverage = 0;

      querySnapshot.forEach((doc) => {
        const { driveKms = 0, fuelPrice = 0, fuelQuantity = 0 } = doc.data();
        totalKMS += driveKms;
        totalPKR += fuelPrice;
        totalFuelQuantity += fuelQuantity;
      });

      if (totalKMS > 0 && totalFuelQuantity > 0) {
        fuelAverage = (totalKMS / totalFuelQuantity).toFixed(2);
      }

      setTotalKMS(totalKMS);
      setTotalPKR(totalPKR);
      setFuelAverage(fuelAverage);
    } catch (error) {
      console.error("Error fetching logbooks:", error);
    }
  };

  useEffect(() => {
    fetchLogbooks();
  }, [notifications]);

  useEffect(() => {
    const fetchDemos = async () => {
      try {
        const today = new Date();
        const todayDateStr = today.toISOString().split("T")[0];

        const collectionRef = collection(fireStore, "Demos");
        const querySnapshot = await getDocs(collectionRef);

        let activityCount = 0;
        const uniqueProducts = new Set();

        querySnapshot.forEach((doc) => {
          const docIdAsTimestamp = new Date(parseInt(doc.id, 10));
          const docDateStr = docIdAsTimestamp.toISOString().split("T")[0];

          console.log("Document ID of Demos:", doc.id);
          console.log("Converted Document Date of Demos:", docDateStr);

          if (docDateStr === todayDateStr) {
            activityCount += 1;
            uniqueProducts.add(doc.data().product);

            // console.log('Matching Document Data of Demos:', doc.data());
            // console.log('Current Activity Count:', activityCount);
            // console.log('Current Unique Products:', uniqueProducts.size);
          }
        });

        setActivityCount(activityCount);
        setUniqueProductCount(uniqueProducts.size);

        // console.log('Final Activity Count:', activityCount);
        // console.log('Final Unique Product Count:', uniqueProducts.size);
      } catch (error) {
        console.error("Error fetching demos:", error);
      }
    };

    fetchDemos();
  }, [notifications]);

  useEffect(() => {
    const fetchFarmerMeetings = async () => {
      try {
        const today = new Date();
        const todayDateStr = today.toISOString().split("T")[0];
        console.log("Today's Date:", todayDateStr);

        const collectionRef = collection(fireStore, "FarmerMeetings");
        const querySnapshot = await getDocs(collectionRef);

        let fm = 0;
        let fd = 0;
        let participants = 0;
        let exps = 0;

        querySnapshot.forEach((doc) => {
          const docIdAsTimestamp = new Date(parseInt(doc.id, 10));
          const docDateStr = docIdAsTimestamp.toISOString().split("T")[0];

          // console.log('Document ID of farmer meetings:', doc.id);
          // console.log('Converted Document Date of farmer meetings:', docDateStr);

          if (docDateStr === todayDateStr) {
            const data = doc.data();
            if (data.farmerMeeting === true) {
              fm += 1;
            } else {
              fd += 1;
            }
            participants += data.numberOfParticipants;
            exps = exps += 1;

            setTotalExp(exps);
          }
        });

        setFmCount(fm);
        setFdCount(fd);
        setTotalParticipants(participants);
        setTotalExp(exps);
      } catch (error) {
        console.error("Error fetching farmer meetings:", error);
      }
    };

    fetchFarmerMeetings();
  }, [notifications]);

  useEffect(() => {
    const fetchFarmers = async () => {
      try {
        const collectionRef = collection(fireStore, "Farmers");
        const querySnapshot = await getDocs(collectionRef);

        // Map through the query snapshot to extract data
        const FarmersList = querySnapshot.docs.map((doc) => {
          const data = doc.data();

          // Convert the 'id' to a timestamp (assuming 'id' is in milliseconds)
          const timestamp = new Date(Number(data.id));
          return {
            ...data,
            id: timestamp, // Replace id with converted timestamp (Date object)
          };
        });

        const sortedFarmerList = FarmersList.sort(
          (a, b) => b.timestamp - a.timestamp
        ); // Sort based on the Date object

        setTotalFarmers(sortedFarmerList.length);

        // Extract unique territories using Set and map to get the actual unique list
        const territoriesSet = new Set(
          sortedFarmerList.map((farmer) => farmer.user?.territory.name)
        );
        const uniqueTerritories = Array.from(territoriesSet); // Convert Set to an array

        // Set the total number of unique territories
        setTotalTerritories(uniqueTerritories.length);
      } catch (error) {
        console.error("Error fetching Farmers:", error);
      }
    };

    fetchFarmers();
  }, [notifications]);

  //Fetch Area Visits...
  useEffect(() => {
    const fetchAreaVisits = async () => {
      // Get today's date
      const today = new Date();
      // Minimum timestamp (start of the day)
      const minDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      const minTimestamp = minDate.getTime();
      // Maximum timestamp (end of the day)
      const maxDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59,
        999
      );
      const maxTimestamp = maxDate.getTime();

      try {
        const collectionRef = collection(fireStore, "AreaVisits"); // Replace with your collection name
        // Create a query with timestamp conditions
        const q = query(
          collectionRef,
          where("id", ">=", minTimestamp),
          where("id", "<=", maxTimestamp)
        );

        const querySnapshot = await getDocs(q);
        const items = querySnapshot.docs.map((doc) => doc.data());
        // Use a Map to ensure uniqueness based on 'user.territory.name'
        const uniqueItems = Array.from(
          new Map(
            items.map((item) => [item.user.territory.name, item])
          ).values()
        );

        setAreaVisits(uniqueItems);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchAreaVisits();
  }, [notifications]);

  // Farmer Meeting Coachings...
  useEffect(() => {
    const fetchFMCoachings = async () => {
      try {
        const collectionRef = collection(fireStore, "FMCoachings");
        const q = query(
          collectionRef,
          where("id", ">=", startDate),
          where("id", "<=", endDate)
        );
        const querySnapshot = await getDocs(q);
        const coachingsList = querySnapshot.docs.map((doc) => {
          return {
            ...doc.data(),
          };
        });

        let fulfilled = 0;
        let skipped = 0;
        let totalReports = 0;

        coachingsList.forEach((data) => {
          if (true) {
            const booleanFields = Object.keys(data).filter(
              (key) => typeof data[key] === "boolean"
            );

            booleanFields.forEach((field) => {
              if (data[field]) {
                fulfilled += 1;
              } else {
                skipped += 1;
              }
            });

            totalReports += 1;
          }
        });

        const totalBooleans = fulfilled + skipped;
        const fulfilledPerc = totalBooleans
          ? (fulfilled / totalBooleans) * 100
          : 0;
        const skippedPerc = totalBooleans ? (skipped / totalBooleans) * 100 : 0;

        setFulfilledPercentage(fulfilledPerc.toFixed(0));
        setSkippedPercentage(skippedPerc.toFixed(0));
        setReportFMCoachingCount(totalReports);
      } catch (error) {
        console.error("Error fetching FM coachings:", error);
      }
    };

    fetchFMCoachings();
  }, [notifications]);

  // Sales Call Coachings...
  useEffect(() => {
    const fetchSSCoachings = async () => {
      try {
        const collectionRef = collection(fireStore, "SSCoachings");
        const q = query(
          collectionRef,
          where("id", ">=", startDate),
          where("id", "<=", endDate)
        );
        const querySnapshot = await getDocs(q);

        const cochingsList = querySnapshot.docs.map((doc) => {
          return {
            ...doc.data(),
          };
        });

        let fulfilledSS = 0;
        let skippedSS = 0;
        let totalReportsSS = 0;

        cochingsList.forEach((data) => {
          if (true) {
            const booleanFields = Object.keys(data).filter(
              (key) => typeof data[key] === "boolean"
            );

            booleanFields.forEach((field) => {
              if (data[field]) {
                fulfilledSS += 1;
              } else {
                skippedSS += 1;
              }
            });

            totalReportsSS += 1;
          }
        });

        const totalSSBooleans = fulfilledSS + skippedSS;
        const fulfilledSSPerc = totalSSBooleans
          ? (fulfilledSS / totalSSBooleans) * 100
          : 0;
        const skippedSSPerc = totalSSBooleans
          ? (skippedSS / totalSSBooleans) * 100
          : 0;

        setFulfilledSSPercentage(fulfilledSSPerc.toFixed(0));
        setSkippedSSPercentage(skippedSSPerc.toFixed(0));
        setReportSSCoachingCount(totalReportsSS);
      } catch (error) {
        console.error("Error fetching SS coachings:", error);
      }
    };

    fetchSSCoachings();
  }, [notifications]);

  // Territories...
  useEffect(() => {
    const fetchTerritories = async () => {
      try {
        const collectionRef = collection(fireStore, "Territories");
        const querySnapshot = await getDocs(collectionRef);

        const territoriesList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Count unique territory names
        const uniqueTerritories = new Set(
          territoriesList.map((territory) => territory.name)
        );
        console.log(uniqueTerritories);
        // setUniqueTerritoryCount(uniqueTerritories.size);
      } catch (error) {
        console.error("Error fetching territories:", error);
      }
    };

    fetchTerritories();
  }, [notifications]);

  const calculateOffset = (percentage) => {
    const circumference = 2 * Math.PI * 16; // 2 * π * r
    return circumference - (percentage / 100) * circumference;
  };

  // Function to determine color based on the percentage
  const getColor = (percentage) => {
    if (percentage >= 75) {
      return "text-green-600";
    } else if (percentage >= 50) {
      return "text-yellow-600";
    } else {
      return "text-red-600";
    }
  };

  const playRingtone = () => {
    audioRef.current.play();
  };

  // Notifications.
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        audioRef.current = new Audio("/sounds/notiring.wav");
        const notificationsRef = ref(database, "Notifications");
        onValue(notificationsRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            playRingtone();
            const notificationsList = Object.keys(data)
              .map((key) => ({ id: key, ...data[key] }))
              .sort((a, b) => b.time - a.time); // Sort by time in descending order
            setNotifications(notificationsList[0]); // Set the latest notification
          } else {
            setNotifications(null);
          }
        });
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
    const dateString = date.toLocaleDateString("en-GB").replace(/\//g, "-"); // Format date as DD-MM-YYYY
    return { time: timeString, date: dateString };
  };

  const { time, date } = formatDate(notifications?.time);
  const offset = calculateOffset(fulfilledPercentage);
  const colorClass = getColor(fulfilledPercentage);
  const offsetSS = calculateOffset(fulfilledSSPercentage);
  const colorClassSS = getColor(fulfilledSSPercentage);

  return (
    <div className="p-4 bg-lightgray h-full overflow-y-scroll">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-3">
        <div className="col-span-2  grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div
            onClick={() => navigate("/logbooks")}
            className="bg-white p-4 rounded-lg shadow-md flex flex-col  transition-transform duration-300 hover:scale-105"
          >
            <div className="flex justify-between">
              <h2 className="font-lato text-darkteal font-extrabold text-lg">
                Daily Log Book
              </h2>
              <img
                src={
                  fuelAverage < 10
                    ? meter1
                    : fuelAverage < 14
                    ? meter2
                    : fuelAverage <= 16
                    ? meter3
                    : meter4
                }
                alt="Fuel Indicator"
                style={{ width: "90px", marginBottom: "16px" }}
              />
            </div>

            <div className="flex justify-between items-center ">
              <h3 className="font-semibold font-lato">KMS</h3>
              <h3 className="font-bold font-lato">{totalKMS || 0}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">PKR</h3>
              <h3 className="font-semibold font-lato">{totalPKR || 0}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">Fuel Average</h3>
              <h3 className="font-semibold font-lato">{fuelAverage || 0}</h3>
            </div>
          </div>

          <div
            onClick={() => navigate("/fmfd")}
            className="bg-white p-4 rounded-lg shadow-md flex flex-col  transition-transform duration-300 hover:scale-105 hover:shadow-xlg"
          >
            <h2 className="font-lato text-darkteal font-extrabold text-lg">
              FM/FD
            </h2>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">FM</h3>
              <h3 className="font-bold font-lato">{fmCount}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">FD</h3>
              <h3 className="font-semibold font-lato">{fdCount}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">Participants</h3>
              <h3 className="font-semibold font-lato">{totalParticipants}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">Total FMFDs</h3>
              <h3 className="font-semibold font-lato">{totalExp || 0}</h3>
            </div>
          </div>

          <div
            onClick={() => navigate("/salescoaching")}
            className="bg-white p-4 rounded-lg shadow-md  transition-transform duration-300 hover:scale-105 hover:shadow-xl"
          >
            <h2 className="font-lato text-darkteal font-extrabold text-lg">
              Sales Call Coaching
            </h2>

            <div>
              <div className="flex justify-between items-center">
                <h3 className="font-semibold font-lato">
                  Overall Score (Last 7 Days)
                </h3>
                <div class="relative size-20">
                  <svg
                    class="size-full -rotate-90"
                    viewBox="0 0 36 36"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="18"
                      cy="18"
                      r="16"
                      fill="none"
                      class="stroke-current text-gray-200"
                      stroke-width="2"
                    ></circle>
                    <circle
                      cx="18"
                      cy="18"
                      r="16"
                      fill="none"
                      className={`stroke-current ${colorClassSS}`}
                      strokeWidth="2"
                      strokeDasharray="100"
                      strokeDashoffset={offsetSS}
                      strokeLinecap="round"
                    ></circle>
                  </svg>

                  <div class="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
                    <span class="text-center text-xl font-bold text-black">
                      {fulfilledSSPercentage}%
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">Fulfilled</h3>
                <h3 className="font-semibold font-lato">
                  {fulfilledSSPercentage}%
                </h3>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">Skipped</h3>
                <h3 className="font-semibold font-lato">
                  {skippedSSPercentage}%
                </h3>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">No of Reports</h3>
                <h3 className="font-semibold font-lato">
                  {reportSSCoachingCount}
                </h3>
              </div>
            </div>
          </div>

          <div
            onClick={() => navigate("/fmfdcoaching")}
            className="bg-white p-4 rounded-lg shadow-lg  transition-transform duration-300 hover:scale-105 "
          >
            <h2 className="font-lato text-darkteal font-extrabold text-lg">
              Farmer Meeting Coaching
            </h2>

            <div>
              <div className="flex justify-between items-center">
                <h3 className="font-semibold font-lato">
                  Overall Score (Last 7 Days)
                </h3>

                <div class="relative size-20">
                  <svg
                    class="size-full -rotate-90"
                    viewBox="0 0 36 36"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="18"
                      cy="18"
                      r="16"
                      fill="none"
                      class="stroke-current text-gray-200"
                      stroke-width="2"
                    ></circle>
                    <circle
                      cx="18"
                      cy="18"
                      r="16"
                      fill="none"
                      className={`stroke-current ${colorClass}`}
                      strokeWidth="2"
                      strokeDasharray="100"
                      strokeDashoffset={offset}
                      strokeLinecap="round"
                    ></circle>
                  </svg>

                  <div class="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
                    <span class="text-center text-xl font-bold text-black">
                      {fulfilledPercentage}%
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">Fulfilled</h3>
                <h3 className="font-semibold font-lato">
                  {fulfilledPercentage}%
                </h3>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">Skipped</h3>
                <h3 className="font-semibold font-lato">
                  {skippedPercentage}%
                </h3>
              </div>

              <div className="flex justify-between items-center mt-2">
                <h3 className="font-semibold font-lato">No of Reports</h3>
                <h3 className="font-semibold font-lato">
                  {reportFMCoachingCount}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-1 space-y-3">
          <div
            onClick={() => navigate("/farmers")}
            className="bg-white p-4 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 "
          >
            <h2 className="font-lato text-darkteal font-extrabold text-lg">
              Farmer Registeration
            </h2>

            <div>
              <div className="flex justify-between items-center mt-7">
                <h3 className="font-semibold font-lato">
                  Registered(All Time)
                </h3>

                <h3 className="font-semibold font-lato">{totalFarmers}</h3>
              </div>

              <div className="flex justify-between items-center mt-3">
                <h3 className="font-semibold font-lato">No of territories</h3>
                <h3 className="font-semibold font-lato">{totalTerritories}</h3>
              </div>
            </div>
          </div>

          <div
            onClick={() => navigate("/areavisits")}
            className="bg-white p-4 rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
          >
            <h2 className="font-lato text-darkteal font-extrabold text-lg">
              Area Visit Reports
            </h2>

            <div>
              <div className="flex justify-between items-center py-6">
                <h3 className="font-semibold font-lato">No of Reports</h3>

                <h3 className="font-semibold font-lato">{areavisits.length}</h3>
              </div>
            </div>
          </div>

          <div
            onClick={() => navigate("/demos")}
            className="bg-white p-4 rounded-lg shadow-lg  transition-transform duration-300 hover:scale-105"
          >
            <h2 className="font-lato font-extrabold text-lg text-darkteal">
              Demos
            </h2>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">Activities</h3>
              <h3 className="font-semibold font-lato">{activityCount}</h3>
            </div>

            <div className="flex justify-between items-center mt-2">
              <h3 className="font-semibold font-lato">Products Express</h3>
              <h3 className="font-semibold font-lato">{uniqueProductCount}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-2 bg-liquidblue p-4 gap-4 rounded-lg">
        <small className=" absolute right-0 bottom-0 mr-4 font-bold text-teal-800">
          POWERED BY: ©BIZCODE
        </small>

        <div
          onClick={() => navigate("/notifications")}
          key={notifications?.id}
          className="bg-white rounded-lg shadow-2xl p-4  transition-transform duration-300 hover:scale-105"
        >
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-lg font-semibold font-lato">
                {notifications?.user?.name || "Representative"}
              </h2>
              <p className="text-gray-600 font-lato">
                {notifications?.user?.phone || "Pakistan Code +92"}
              </p>
              <p className="mt-2 text-gray-700 font-lato font-bold">
                {notifications?.info || "Activity Performed"}
              </p>
            </div>
            <div className="text-liquidblue font-bold font-lato">
              {notifications?.user?.territory?.zone || "ZONE"}
            </div>
          </div>
          <div className="mt-2 flex justify-between items-center">
            <p className="text-gray-600 text-sm font-lato">{time || "TIME"}</p>
            <p className="text-gray-600 text-sm font-lato">{date || "DATE"}</p>
          </div>
          <div className="mt-2">
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="bg-green-500 h-2.5 rounded-full"
                style={{ width: `${notifications?.progress}%` }}
              ></div>
            </div>
            <p className="text-right text-green-500 font-bold mt-2 font-lato">
              {notifications?.progress}%
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
